var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 45",
    style: {
      enableBackground: "new 0 0 100 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#FFFFFF;} .st1{display:none;} .st2{display:inline;} .st3{fill:#272661;} .st4{fill:#EC2747;} .st5{fill:#55A986;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.4,7.7 13.9,7.7 13.9,11.4 7.8,11.4 7.8,14.1 13.2,14.1 13.2,17.8 7.8,17.8 7.8,24.5 3.4,24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.2,24.5L39.7,20h-2.7v4.5h-4.4V7.7h7c3.4,0,6.1,2.7,6.1,6.1c0,1.7-0.7,3.4-2,4.5l3.5,6.1L42.2,24.5z M36.9,16.3h2.7c1.3,0,2.4-1,2.4-2.4c0-1.3-1-2.4-2.3-2.4h-2.9V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,20.8h-1c-0.7,0-1.3-0.6-1.3-1.3l0,0v-6.9c0-0.7,0.6-1.3,1.3-1.3l0,0h1V7.8c-4.6,0.3-8.1,4.4-7.7,9 c0.3,4.1,3.6,7.4,7.7,7.7V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,7.8v3.6h1c0.7,0,1.3,0.6,1.3,1.3l0,0v6.9c0,0.7-0.6,1.3-1.3,1.3l0,0h-1v3.6c4.6-0.3,8.1-4.4,7.7-9 C30.3,11.3,27.1,8.1,22.9,7.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.7,7.7 59.1,7.7 59.1,11.4 53.1,11.4 53.1,14.1 58.4,14.1 58.4,17.8 53.1,17.8 53.1,20.9 59.1,20.9 59.1,24.5 48.7,24.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.6,14.9 78,7.3 72.7,7.3 70,11.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.6,21.8 72.1,15.6 72.1,15.5 72.1,15.5 62.4,1.6 62.4,1.6 62.3,1.5 57.1,1.5 66.8,15.5 56.5,30.2 61.7,30.2 67.7,21.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.5,17.6 66,15.5 66,15.5 62.7,10.8 62.7,10.8 62.7,10.8 60.9,10.8 64.2,15.5 60.7,20.5 62.5,20.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.7,17.6 73.7,17.6 72.7,16.2 70,19.9 73.3,24.5 78.5,24.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.7,27 46,27 46,30.6 40.1,30.6 40.1,33.2 45.3,33.2 45.3,36.9 40.1,36.9 40.1,39.9 46,39.9 46,43.4 35.7,43.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64,27 58.5,34.8 64.5,43.4 59.3,43.4 55.9,38.6 52.5,43.4 47.2,43.4 53.2,34.8 47.7,27 53,27 55.9,31.1 58.7,27 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,27h6.9c3.3,0,6,2.8,6,6.1c0,3.2-2.6,5.9-5.9,6h-2.7v4.4H66L66,27z M70.3,35.4H73c1.3,0,2.4-1,2.4-2.3 c0-1.3-1-2.3-2.2-2.4h-2.8L70.3,35.4L70.3,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,27c4.5,0,8.2,3.7,8.3,8.2c0,4.5-3.7,8.2-8.2,8.3c-4.5,0-8.2-3.7-8.3-8.2c0,0,0,0,0,0 C80.1,30.7,83.8,27,88.3,27 M88.3,31.3c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9s3.9-1.7,3.9-3.9l0,0 C92.3,33.1,90.5,31.3,88.3,31.3C88.4,31.3,88.4,31.3,88.3,31.3L88.3,31.3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_1_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3.4,7.7 13.9,7.7 13.9,11.4 7.8,11.4 7.8,14.1 13.2,14.1 13.2,17.8 7.8,17.8 7.8,24.5 3.4,24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.2,24.5L39.7,20h-2.7v4.5h-4.4V7.7h7c3.4,0,6.1,2.7,6.2,6.1c0,1.7-0.7,3.4-2,4.5l3.5,6.1L42.2,24.5z M36.9,16.2h2.7c1.3,0,2.4-1,2.4-2.4c0-1.3-1-2.4-2.3-2.4h-2.9V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.5,20.8h-1c-0.7,0-1.2-0.6-1.2-1.2c0,0,0,0,0,0v-6.9c0-0.7,0.6-1.2,1.2-1.2c0,0,0,0,0,0h1V7.8 c-4.6,0.4-8.1,4.4-7.7,9c0.3,4.1,3.6,7.4,7.7,7.7V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23,7.8v3.6h1c0.7,0,1.2,0.6,1.2,1.2c0,0,0,0,0,0v6.9c0,0.7-0.6,1.2-1.2,1.2c0,0,0,0,0,0h-1v3.6 c4.6-0.4,8.1-4.4,7.7-9C30.3,11.4,27.1,8.1,23,7.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "48.7,7.7 59.1,7.7 59.1,11.4 53.1,11.4 53.1,14.1 58.4,14.1 58.4,17.8 53.1,17.8 53.1,20.9 59.1,20.9 59.1,24.5 48.7,24.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "72.6,14.9 78,7.3 72.7,7.3 70,11.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.7,21.8 72.1,15.5 72.1,15.5 72.1,15.5 62.4,1.6 62.4,1.6 62.3,1.5 57.1,1.5 66.8,15.5 56.5,30.2 61.7,30.2 67.7,21.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "64.5,17.6 66,15.5 66,15.5 62.7,10.8 62.7,10.8 62.7,10.8 60.9,10.8 64.2,15.5 60.7,20.5 62.5,20.5 64.5,17.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "73.7,17.6 73.7,17.6 72.7,16.2 70,19.9 73.3,24.5 78.5,24.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "35.8,27 46,27 46,30.6 40.1,30.6 40.1,33.2 45.3,33.2 45.3,36.9 40.1,36.9 40.1,39.9 46,39.9 46,43.4 35.8,43.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "64,27 58.5,34.9 64.5,43.4 59.3,43.4 55.9,38.6 52.5,43.4 47.2,43.4 53.2,34.9 47.7,27 53,27 55.9,31.1 58.7,27 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66,27h6.9c3.3,0.1,6,2.8,6,6.1c0,3.2-2.6,5.9-5.9,6h-2.7v4.4H66L66,27z M70.3,35.4H73c1.3,0,2.4-1,2.4-2.3 c0-1.3-1-2.3-2.2-2.4h-2.8V35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.3,27c4.5,0,8.2,3.7,8.3,8.2s-3.7,8.2-8.2,8.3c-4.5,0-8.2-3.7-8.3-8.2c0,0,0,0,0,0 C80.1,30.7,83.8,27,88.3,27 M88.3,31.3c-2.2,0-3.9,1.8-3.9,3.9c0,2.2,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9l0,0 C92.3,33.1,90.5,31.3,88.3,31.3C88.4,31.3,88.3,31.3,88.3,31.3L88.3,31.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.205a6a2df75abda7fe26ee4069f0b1a4.svg";
export { ForwardRef as ReactComponent };